import React from "react";
import { inject } from "mobx-react";
import Button from "ComponentsUI/Button";
import { Link, withRouter } from "react-router-dom";
import withStyles from "react-jss";
import { generateUrl } from "Services/withDefaultParams";
//TODO Понять, почему нельзя изменять
var Routes = require("Configs/routes");

const styles = (theme) => ({
	btnAllTariffs: {
		display: "block",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		btnAllTariffs: {
			display: "none",
		},
	},
});

const AllTariffsButton = (props) => {
	const showTariffHandler = () => {
		let providerModel = props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_tariffs");
	};

	let text = props.ApplicationModel.text;
	let classes = props.classes;
	let providerRatesUrl = generateUrl(Routes.ProviderRates.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	return (
		<div className={classes.btnAllTariffs}>
			<Button
				stub={false}
				typeText="big"
				component={<Link to={!!providerRatesUrl ? providerRatesUrl : "/"} />}
				size={"middle"}
				status={"purple"}
				datatest="providers_provider_alltariff_button"
				fullWidth={true}
				onClick={() => showTariffHandler()}
			>
				{text.ALL_RATES}
			</Button>
		</div>
	);
};

export default withRouter(withStyles(styles)(inject("ApplicationModel")(AllTariffsButton)));
